export { default } from "./ClassesSettingsPage";
